// extracted by mini-css-extract-plugin
export default {"medium":"only screen and (min-width: 768px)","button":"ZAtRW","icon":"f0TVE"};